export function favoriteMyListGet(page) {
	return {
    type: 'FAVORITE_MY_LIST_GET',
		payload: {
			page: page,
		},
	}
}


export function favoriteMyAdd(pic, notice, callback) {
	return {
    type: 'FAVORITE_MY_ADD',
    payload: {
			pic: pic,
			notice: notice,
		},
		callback: callback,
	}
}

export function favoriteMyDel(pic, callback) {
	return {
    type: 'FAVORITE_MY_DEL',
    payload: {
			pic: pic,
		},
		callback: callback,
	}
}


export function favoritePartnerListGet(page) {
	return {
    type: 'FAVORITE_PARTNER_LIST_GET',
		payload: {
			page: page,
		},
	}
}


export function favoritePartnerDel(pic, callback) {
	return {
    type: 'FAVORITE_PARTNER_DEL',
    payload: {
			pic: pic,
		},
		callback: callback,
	}
}
